"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecordingStatus = getRecordingStatus;
exports.getStreamStartingStatus = getStreamStartingStatus;
exports.getStreamingStatus = getStreamingStatus;
exports.isRecording = isRecording;
exports.isStreamStarting = isStreamStarting;
exports.isStreaming = isStreaming;
var _StreamStates = require("../constants/StreamStates");
/**
 * @description Returns whether the endpoint that is streaming.
 * @param endpoint
 */
function isStreaming(endpoint) {
  return (endpoint === null || endpoint === void 0 ? void 0 : endpoint.isStreaming) || endpoint.status === _StreamStates.STARTED;
}

/**
 * @description Returns whether the endpoint that is starting.
 * @param endpoint
 */
function isStreamStarting(endpoint) {
  return (endpoint === null || endpoint === void 0 ? void 0 : endpoint.isStarting) || endpoint.status === _StreamStates.STARTING;
}

/**
 * @description Returns whether the recording has started.
 * @param recording
 */
function isRecording(recording) {
  return (recording === null || recording === void 0 ? void 0 : recording.isRecording) || recording.status === _StreamStates.STARTED;
}

/**
 * @description Returns whether there's any endpoint that is streaming.
 * @param {[]} endpoints
 */
function getStreamingStatus(endpoints) {
  return endpoints === null || endpoints === void 0 ? void 0 : endpoints.some(isStreaming);
}

/**
 * @description Returns whether there's any endpoint that is starting.
 * @param {[]} endpoints
 */
function getStreamStartingStatus(endpoints) {
  return endpoints === null || endpoints === void 0 ? void 0 : endpoints.some(isStreamStarting);
}

/**
 * @description Returns whether there's any recording that has started.
 * @param {[]} recordings
 */
function getRecordingStatus(recordings) {
  return recordings === null || recordings === void 0 ? void 0 : recordings.some(isRecording);
}